import { render } from "./Appointment.vue?vue&type=template&id=7b315e9e"
import script from "./Appointment.vue?vue&type=script&lang=ts"
export * from "./Appointment.vue?vue&type=script&lang=ts"

import "./Appointment.vue?vue&type=style&index=0&id=7b315e9e&lang=css"
script.render = render

export default script